module.exports = __webpack_public_path__ + "img/logo_smarky_entrance_ol.3e2e16e2.png";